import React from "react";
import "./DataHolder.scss";

export const DetailsComponent = ({ title, subTitle,title1,title2,title3,title4,title1Count,title2Count,title3Count,title4Count }) => {
    return (
        <div className="box_design_Details">
            <div className="title_details_component">{title}<br />
            <div>{subTitle}</div></div>
            <div class="container">
                <div class="column details_text">{title1}</div>
                <div class="column details_text textright">{title1Count}</div>
            </div>
            <div class="container">
                <div class="column details_text">{title2}</div>
                <div class="column details_text textright">{title2Count}</div>
            </div><div class="container">
                <div class="column details_text">{title3}</div>
                <div class="column details_text textright">{title3Count}</div>
            </div><div class="container">
                <div class="column details_text">{title4}</div>
                <div class="column details_text textright">{title4Count}</div>
            </div>
        </div>
    );
};
